export default {
  main: '#F26F21',
  text: '#191919'
}